import { JSONSchema7Type } from 'json-schema';
import ControlState from '../../Shared/controlState';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';

export default (control: ControlState) => {
  const ctrlProperties = control.schema?.properties as JSONSchema7Properties;
  const defaultValue = ctrlProperties['value']?.default as JSONSchema7Type;
  const defaultValues: Record<string, unknown> = {};

  defaultValues[`${control.id}-value`] = defaultValue as string;
  defaultValues[`${control.id}-status`] = '';

  return defaultValues;
};
